import React from "react";

import IssuerNavbar from "components/IssuerNavbar";
import Footer from "components/Footers";
import AuthGuard from "components/Guards/AuthGuard";
import { renderRoutes } from "routes";
import routes from "routes";

const IssuerLayout = (props) => {
    // Add [] so this runs only on mount/unmount, not on every render.
    // The body class is stable for the lifetime of this layout — running the
    // add/remove on every render was wasteful (and the direct classList call
    // that was here before was a side-effect in render, also moved in).
    React.useEffect(() => {
        document.documentElement.classList.remove("nav-open");
        document.body.classList.add("profile-page");
        return () => {
            document.body.classList.remove("profile-page");
        };
    }, []);

    return (
        <AuthGuard>
            <>
                <IssuerNavbar />
                <div className="main">
                    {renderRoutes(routes)}
                </div>
                <Footer fluid />
            </>
        </AuthGuard>
    );
};

export default IssuerLayout;
